module.exports = __webpack_public_path__ + "media/images/default/lp_feature_1-b5e050f906ca63f3a4c4872302e61567.svg";